import Link from 'components/Link'
import React from 'react'
import enterpriseReady from './enterprise-ready.png'
import { GatsbyImage } from 'gatsby-plugin-image'
import { getSeoGatsbyImage } from 'utils/googleData'

const Listing = ({ name, image, url, badge, price, gatsbyImage }) => {
    return (
        <li className="border-b border-r border-dashed border-gray-accent-light">
            <Link
                to={url}
                className="relative flex flex-col items-center justify-center px-2 py-8 text-center hover:bg-gray-accent-light"
            >
                {image && <img className="icon mb-2 h-12 w-12 rounded-sm p-2" src={image} />}
                {gatsbyImage && <GatsbyImage className="icon mb-2 h-12 w-12 rounded-sm p-2" image={gatsbyImage} />}

                <span className="text-primary dark:text-white">{name}</span>
                <div className="absolute top-4 right-4 inline-flex items-center space-x-2 text-[12px] uppercase text-primary text-opacity-50 dark:text-white">
                    {badge && <span className="rounded-[2px] bg-gray-accent-light px-2 py-1">{badge}</span>}
                    {badge?.toLowerCase() !== 'built-in' && <span>{price || 'Free'}</span>}
                </div>
            </Link>
        </li>
    )
}

export default function AppsList({ apps, hideBuildYourOwn }) {
    return (
        <ul className="m-0 mx-auto grid max-w-screen-2xl list-none grid-cols-2 border-t border-l border-dashed border-gray-accent-light p-0 md:grid-cols-4">
            {apps?.length > 0 &&
                apps.map((app) => {
                    const price = app?.frontmatter?.price
                    const id = app?.id
                    const thumbnailImg = getSeoGatsbyImage({
                        googleImages: [app?.parent?.images, app?.parent?.images2],
                    })
                    const title = app?.frontmatter?.title
                    const slug = app?.fields?.slug
                    const badge = app?.frontmatter?.badge
                    console.log('thumbnailImg', console.log([app?.parent?.images, app?.parent?.images2]))
                    return (
                        <Listing
                            key={id}
                            badge={badge}
                            name={title}
                            // image={thumbnail?.publicURL}
                            gatsbyImage={thumbnailImg}
                            url={slug}
                            price={price}
                        />
                    )
                })}
            {!hideBuildYourOwn && (
                <li className="relative inline-flex min-h-[160px] items-center justify-center overflow-hidden border-dashed border-gray-accent-light bg-red">
                    <Link
                        className="flex h-full w-full items-center justify-center space-x-4"
                        to="/docs/marketplace/build"
                    >
                        <img
                            className="left-[-37px] bottom-[-32px] min-w-[100px] max-w-[32%] -scale-x-1 md:absolute"
                            src={enterpriseReady}
                            alt=""
                        />
                        <h3 className="relative m-0 text-[1.2rem] text-white md:text-[1.5rem]">Become a Partner</h3>
                    </Link>
                </li>
            )}
        </ul>
    )
}
